import LeadCardEvent from './LeadCardEvent';
import { getLeadCreationEventId, shouldHideLeadCreationAuthor } from '../helpers/isExternalLeadCreationEvent';
import type { LeadCardHistoryProps } from '../types';

const LeadCardHistory = ({ lead, events, fetchLead, showLockButton = true }: LeadCardHistoryProps) => {
    const creationEventId = getLeadCreationEventId(events);

    return (
        <div className="lead-events-list">
            {events &&
                events.map((event) => (
                    <LeadCardEvent
                        showLockButton={showLockButton}
                        fetchLead={fetchLead}
                        key={`event-${event.eventCreated}`}
                        event={event}
                        hideAuthor={shouldHideLeadCreationAuthor(lead, event, creationEventId)}
                    />
                ))}
        </div>
    );
};

export default LeadCardHistory;
